'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Icon = require('../../Icon/src/Icon.js');
var Space = require('../../Space/src/Space.js');
require('../../Transition/src/Fade.js');
require('../../Transition/src/ScaleFade.js');
require('../../Transition/src/SlideFade.js');
var Collapse = require('../../Transition/src/Collapse.js');
var Accordion_module = require('../styles/Accordion.module.less.js');
var AccordionContext = require('./AccordionContext.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Accordion Item component.
 *
 * @component
 * @example
 * ```jsx
 * <Accordion.Item key="credit" title="О кредите">content</Accordion.Item>
 * ```
 */
const Item = React__namespace.forwardRef((props, ref) => {
    const { id, title, subtitle, icon, active, tabIndex, unmountOnExit = true, className, children, onChange, ...restProps } = props;
    const activeItemRef = React__namespace.useRef(null);
    const { padding, scrollIntoView, onCollapse, size } = React__namespace.useContext(AccordionContext.default);
    const [enableAnimation, setEnableAnimation] = reactUtils.useBoolean(false);
    const cx = reactUtils.useStyles(Accordion_module.default);
    const headerClassNames = cx('header', {
        active,
        [`size-${size}`]: size,
        padding,
    });
    const contentClassNames = cx('content', { [`size-${size}`]: size, padding });
    const collapse = React__namespace.useCallback((event) => {
        if (scrollIntoView) {
            activeItemRef.current = event.currentTarget.closest('[data-qa=CollapseItem]');
            setTimeout(() => {
                activeItemRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 300);
        }
        onChange?.(!active);
        onCollapse?.(event);
    }, [scrollIntoView, onChange, active, onCollapse]);
    const handleCollapse = (event) => {
        collapse(event);
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            collapse(event);
        }
    };
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "CollapseItem", className: cx(className, 'panel', { active }), ...restProps },
        React__namespace.createElement("div", { className: headerClassNames, "data-index": id, tabIndex: tabIndex, onFocus: setEnableAnimation.on, onClick: children ? handleCollapse : reactUtils.noop, onKeyDown: handleKeyDown },
            React__namespace.createElement(Space.Space, { size: 12, align: "center" },
                icon && React__namespace.createElement("div", { className: cx('icon') }, icon),
                title || subtitle ? (React__namespace.createElement(Space.Space, { direction: "vertical", size: 2, className: cx('title-wrapper') },
                    title && React__namespace.createElement("div", { className: cx('title') }, title),
                    subtitle && React__namespace.createElement("div", { className: cx('subtitle') }, subtitle))) : null),
            children && React__namespace.createElement(Icon.Icon, { className: cx('collapse-icon'), icon: React__namespace.createElement(reactIcons.ArrowDown, null) })),
        React__namespace.createElement(Collapse.Collapse, { visible: active, enableAnimation: enableAnimation, className: contentClassNames, unmountOnExit: unmountOnExit },
            React__namespace.createElement("div", { className: cx('content-wrapper') }, children))));
});
Item.defaultProps = {
    tabIndex: 0,
    unmountOnExit: true,
};
Item.displayName = 'Item';

exports.Item = Item;
//# sourceMappingURL=AccordionItem.js.map
